import { useStoreWeightUnit } from '@core/context';
import { WeightUnitType } from '@core/type';
import { HookStoreFn, WeightUnitHook, WeightUnitState } from '@core/type/context';

export const useWeightUnit: HookStoreFn<WeightUnitState, WeightUnitHook> = () => {
  const [weightUnit, setWeightUnit] = useStoreWeightUnit<WeightUnitType>('weightUnit');

  return { weightUnit, setWeightUnit };
};
